var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-card',{staticClass:"mt-2"},[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}},[_c('div',[_vm._v("informações internas")]),_c('div',[_vm._v("circular apenas entre pessoas autorizadas.")])]),_c('b-col',[_c('h3',[_c('b-badge',{attrs:{"pill":""}},[_vm._v("pesquisa e conhecimento")])],1)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }